var map = {
	"./black/index.js": [
		"962e",
		"chunk-6689e9fe"
	],
	"./blue/index.js": [
		"7612",
		"chunk-5cd5538e"
	],
	"./golden/index.js": [
		"f5d4",
		"chunk-46f3300e"
	],
	"./green/index.js": [
		"23be",
		"chunk-2fdfd1f8"
	],
	"./red/index.js": [
		"9529",
		"chunk-eb1ece8e"
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(function() {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "ab12";
module.exports = webpackAsyncContext;